import { Icon } from '@doordash/design-language';

var IconTypes = Icon.Types;
var TagSize;

(function (TagSize) {
  TagSize["XSmall"] = "XSmall";
  TagSize["Small"] = "Small";
  TagSize["Medium"] = "Medium";
  TagSize["Large"] = "Large";
})(TagSize || (TagSize = {}));

var TagType;

(function (TagType) {
  TagType["HighlightDefault"] = "HighlightDefault";
  TagType["HighlightEmphasis"] = "HighlightEmphasis";
  TagType["HighlightSubdued"] = "HighlightSubdued";
  TagType["InformationalDefault"] = "InformationalDefault";
  TagType["InformationalEmphasis"] = "InformationalEmphasis";
  TagType["InformationalSubdued"] = "InformationalSubdued";
  TagType["NegativeDefault"] = "NegativeDefault";
  TagType["NegativeEmphasis"] = "NegativeEmphasis";
  TagType["NegativeSubdued"] = "NegativeSubdued";
  TagType["PositiveDefault"] = "PositiveDefault";
  TagType["PositiveEmphasis"] = "PositiveEmphasis";
  TagType["PositiveSubdued"] = "PositiveSubdued";
  TagType["WarningDefault"] = "WarningDefault";
  TagType["WarningEmphasis"] = "WarningEmphasis";
  TagType["WarningSubdued"] = "WarningSubdued";
})(TagType || (TagType = {}));

export { IconTypes, TagSize, TagType };
